import { useEffect } from 'react';

type DialogKeyboardOptions = {
  onClose?: () => void;
  blockEscape?: boolean;
};

/**
 * Close a dialog on Escape.
 */
export function useDialogKeyboard(open: boolean, options: DialogKeyboardOptions = {}): void {
  const { onClose, blockEscape = false } = options;

  useEffect(() => {
    if (!open || blockEscape || !onClose) return undefined;

    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose, blockEscape]);
}
